import React, { Component } from 'react';

export default class FilteredInput extends Component {
    constructor() {
        super();

        this.state = { value: '' };
        this.changeValue = this.changeValue.bind(this);
        this.catchKeypress = this.catchKeypress.bind(this);
        this.timeout = null;
        this.lastCorrectValue = null;

        this.defaultTimeoutTime = 750;
    }

    render() {
        if (typeof this.props.fieldName === 'string' && this.props.fieldName) {
            const getLabel = () => {
                if (typeof this.props.label === 'string' && this.props.label.length > 0) {
                    return (
                        <label htmlFor={this.props.fieldName} className="form__label">
                            {this.props.label}
                            {typeof this.props.required === 'boolean' && this.props.required ? (
                                <sup> *</sup>
                            ) : (
                                <></>
                            )}
                        </label>
                    );
                } else return <></>;
            };

            return (
                <>
                    {getLabel()}
                    <input
                        type={'text'}
                        name={this.props.fieldName}
                        className="form__input"
                        title={
                            typeof this.props.title === 'string' && this.props.title.length > 0
                                ? this.props.title
                                : null
                        }
                        onKeyUp={this.changeValue}
                        onChange={this.changeValue}
                        onKeyPress={this.catchKeypress}
                        value={this.state.value}
                        required={typeof this.props.required === 'boolean' && this.props.required}
                    />
                </>
            );
        } else {
            console.error('fieldName is obligatory!');
            return <></>;
        }
    }

    catchKeypress(e) {
        if (typeof this.props.charCodeFilter === 'function') {
            const result = this.props.charCodeFilter(e.charCode);
            if (result === false) {
                e.preventDefault();
            }
        }
    }

    changeValue(e) {
        const val = e.target.value;

        this.setState({ value: val });
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(val);
        }
    }
}
